import { render, staticRenderFns } from "./CatBanner3.vue?vue&type=template&id=164fe886&"
import script from "./CatBanner3.vue?vue&type=script&lang=js&"
export * from "./CatBanner3.vue?vue&type=script&lang=js&"
import style0 from "./CatBanner3.vue?vue&type=style&index=0&id=164fe886&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports